.icon-color-blue {
  color: #219bfd;
}

.icon-color-blue:hover, .icon-color-blue:focus {
  color: #219bfd;
}

.icon-color-grey {
  color: #9fa0a4;
}

.icon-color-grey:hover, .icon-color-grey:focus {
  color: #9fa0a4;
}

.icon-color-grey:hover + .tooltip-text {
  color: #626469;
}

.tooltip-icon {
  display: block;
  width: 18px;
  height: 18px;
  cursor: pointer;
  color: #9fa0a4;
}

.tooltip-icon.active {
  color: #626469;
}

.tooltip-label-container {
  display: flex;
  align-items: center;
}

:host(:not([dir="rtl"])) .tooltip-text {
  padding-left: 5px;
}

:host([dir="rtl"]) .tooltip-text {
  padding-right: 5px;
}